import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authAPI } from '../services/api';
import { Alert, PasswordInput } from '../components/ui';
import './login.css';

export default function Login() {
  const [mode, setMode] = useState('login');
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'Member', title: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(form.email, form.password);
        navigate('/app');
      } else if (mode === 'register') {
        await authAPI.register({ name: form.name, email: form.email, password: form.password, role: form.role, title: form.title });
        await login(form.email, form.password);
        navigate('/app');
      } else if (mode === 'forgot') {
        if (form.password !== form.confirmPassword) {
          setError('Passwords do not match');
          setLoading(false);
          return;
        }
        if (form.password.length < 6) {
          setError('Password must be at least 6 characters');
          setLoading(false);
          return;
        }
        
        const res = await authAPI.resetPasswordDirect({ email: form.email, newPassword: form.password });
        setError(res.data.message || 'Password successfully reset.');
        // After 2 seconds, switch back to login mode
        setTimeout(() => {
          setMode('login');
          setForm(f => ({ ...f, password: '', confirmPassword: '' }));
          setError('');
        }, 2000);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Check backend is running.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__mesh">
        <div className="login-page__mesh-1" />
        <div className="login-page__mesh-2" />
        <div className="login-page__grid" />
      </div>

      <div className="login-page__container">
        <div className="login-page__brand">
          <div className="login-page__logo">P</div>
          <h1 className="login-page__title">ProjectHub</h1>
          <p className="login-page__tagline">Modern project & team management</p>
        </div>

        <div className="login-page__card">
          <div className="login-page__tabs">
            {['login', 'register'].map((m) => (
              <button
                key={m}
                type="button"
                className={`login-page__tab${mode === m ? ' login-page__tab--active' : ''}`}
                onClick={() => { setMode(m); setError(''); }}
              >
                {m}
              </button>
            ))}
          </div>

          {error && <Alert type={error.includes('successfully') ? "success" : "error"} message={error} />}

          <form onSubmit={handleSubmit}>
            {mode === 'register' && (
              <div className="login-page__field">
                <label className="login-page__label">Full Name</label>
                <input placeholder="Your full name" value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} required />
              </div>
            )}
            
            <div className="login-page__field">
              <label className="login-page__label">Email {mode !== 'forgot' && '/ Unique code'}</label>
              <input type={mode === 'forgot' ? "email" : "text"} placeholder={mode === 'forgot' ? "you@example.com" : "you@example.com or UNIQUECODE"} value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} required />
            </div>

            <div className="login-page__field">
              <label className="login-page__label">{mode === 'forgot' ? 'New Password' : 'Password'}</label>
              <PasswordInput placeholder="••••••••" value={form.password} onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))} required />
            </div>

            {mode === 'forgot' && (
              <div className="login-page__field">
                <label className="login-page__label">Confirm New Password</label>
                <PasswordInput placeholder="••••••••" value={form.confirmPassword} onChange={(e) => setForm((f) => ({ ...f, confirmPassword: e.target.value }))} required />
              </div>
            )}

            {mode === 'register' && (
              <div className="login-page__field">
                <label className="login-page__label">Role</label>
                <select value={form.role} onChange={(e) => setForm((f) => ({ ...f, role: e.target.value }))}>
                  <option>Member</option>
                  <option>Manager</option>
                  <option>Client</option>
                </select>
              </div>
            )}
            {mode === 'register' && form.role === 'Client' && (
              <div className="login-page__field">
                <label className="login-page__label">Title / Company</label>
                <input placeholder="Job Title or Company Name" value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} required />
              </div>
            )}

            {mode === 'login' && (
              <div className="login-page__field" style={{ textAlign: 'right', marginTop: '-10px', marginBottom: '10px' }}>
                <button type="button" onClick={() => { setMode('forgot'); setError(''); }} style={{ background: 'none', border: 'none', color: 'var(--accent)', cursor: 'pointer', fontSize: '0.85rem' }}>
                  Forgot Password?
                </button>
              </div>
            )}

            <button type="submit" disabled={loading} className="login-page__submit">
              {loading ? 'Please wait...' : mode === 'login' ? 'Sign In' : mode === 'register' ? 'Create Account' : 'Reset Password'}
            </button>

            {mode === 'forgot' && (
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <button type="button" onClick={() => { setMode('login'); setError(''); }} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '0.9rem' }}>
                  Back to Sign In
                </button>
              </div>
            )}
          </form>
        </div>

        {/* <div className="login-page__hint">
          Backend must be running on <strong>localhost:5000</strong>
        </div> */}
      </div>
    </div>
  );
}
